export function buildCollectionPath(
  collectionPath: string,
  params: { [placeholder: string]: string } = {}
) {
  for (const [placeholder, value] of Object.entries(params || {})) {
    collectionPath = collectionPath.replace(`{{${placeholder}}`, value);
  }
  return collectionPath;
}

